export default {
      id: "close-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#close",
      toString: function () {
        return this.url;
      }
    }